
import { mapGetters } from 'vuex'
export default {
  inject: ['product', 'wording'],
  data() {
    return {
      product: this.product,
      wording: this.wording,
    }
  },
  computed: {
    ...mapGetters({
      vxFeatures: 'common/getFeatureListPdp',
    }),
    features() {
      const lang = this.$i18n.locale.split('-')[0].toLowerCase()
      return this.product?.features?.reduce((acc, feature) => {
        const label = this.vxFeatures?.[feature]?.[lang]
        if (label) {
          acc.push({ key: feature, label })
        }
        return acc
      }, [])
    },
  },
}
